import whenDomReady from 'when-dom-ready';
import { tns } from 'tiny-slider/src/tiny-slider';

function initialize() {
  const carousels = document.querySelectorAll('.js-es-step-carousel');
  const nav = document.querySelector('.ds-step-carousel__nav');
  const controls = document.querySelector('.ds-step-carousel__controls');

  if (!carousels) {
    return;
  }

  Array.from(carousels).forEach(carousel => {
    const slider = tns({
      container: carousel,
      items: 1,
      loop: false,
      swipeAngle: false,
      slideBy: 'page',
      speed: 400,
      nav: true,
      navContainer: nav,
      controlsContainer: controls,
    });

    const buttonsNext = document.querySelectorAll('.js-step-carousel-next');
    const buttonsFirst = document.querySelectorAll('.js-step-carousel-first');

    if (buttonsNext) {
      Array.from(buttonsNext).forEach(button => {
        button.addEventListener('click', () => slider.goTo('next'));
      });
    }

    if (buttonsFirst) {
      Array.from(buttonsFirst).forEach(button => {
        button.addEventListener('click', () => slider.goTo('first'));
      });
    }
  });
}

whenDomReady().then(initialize);
